import { Suspense } from 'react';
import { RouterProvider } from 'react-router-dom';
import {
  ErrorBoundary,
  PageLoader,
  RefreshPage,
  SomeThingWentWrongModal,
} from '@tasama/ui';
import { AuthProvider } from './core/providers/AuthProvider';
import { router } from './core/router';
import { getSessionConfig } from './config/session-config';
import { NewTicketDrawer } from './shared/components/NewTicketDrawer';
import BusinessAdvisorFeature from './features/businessAdvisor/BusinessAdvisorFeature';
import { usePageTracking } from './shared/hooks/use-page-tracking';

function App() {
  usePageTracking();

  // Get session configuration from environment or use defaults
  const sessionConfig = getSessionConfig();

  return (
    <ErrorBoundary
      testID="app-portal-error-boundary"
      onError={(_error: Error, _errorInfo: React.ErrorInfo) => {
        // Log to monitoring service in production
      }}
      resetOnPropsChange={false}
      className="min-h-screen"
    >
      <SomeThingWentWrongModal />
      <RefreshPage />
      <PageLoader />
      <AuthProvider inactivityTimeout={sessionConfig.inactivityTimeout}>
        <Suspense fallback={<PageLoader />}>
          <RouterProvider router={router} />
        </Suspense>
        {/* Global NewTicketDrawer - controlled via useNewTicketDrawerStore */}
        <NewTicketDrawer />
        <BusinessAdvisorFeature />
      </AuthProvider>
    </ErrorBoundary>
  );
}

export default App;
